import React, { useState, useImperativeHandle, useEffect, useRef, useCallback } from 'react'

//images
import headImage from '@/assets/img/modals/send/icons/head.svg'
import closeIcon from '../../../../assets/img/icons/close.png'
import deleteIcon from '../../../../assets/img/icons/delete.svg'
import Api from '../../../../_helpers/Api'
import loader from '../../../../assets/img/loader.svg'
import Dropdown from '../../../partials/Dropdown'
import Ckeditor from '../../../partials/Ckeditor'
import { trans } from '../../../../_providers/Translation'
import { Checkbox, FormControlLabel } from '@mui/material'
import "@/assets/scss/pages/communication.scss"

function AddOrEdit(props, ref) {

    const formRef = useRef(null)

    const defaultData = {
        repeat: false,
        repeat_after: 1,
        send_to_all: 0,
        receivers: [],
        original: [],
        selected: [],
        characters: 0,
        group: null,
        method: 'sms'
    }

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        edit: false,
        editId: null,
        data: defaultData,
        dataLoading: false,
        loading: false,
        url: null
    })

    const [validations, setValidations] = useState(null)

    const charactersPerSms = 160

    //NEW: Допълнителна функция за изпращане на съобщението
    const handleSendMessage = () => {
        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        let data = new FormData(formRef.current)
        data.append('id', popup.editId)

        Api.post('text-messages/send-now', data).then(res => {
            setPopup(prev => ({
                ...prev,
                loading: false,
            }))
            if (props.handleSendMessage) {
                props.handleSendMessage()
            }
            handleHide()
        }).catch(err => {
            setPopup(prev => ({
                ...prev,
                loading: false,
            }))
            console.log(err)
        })
    }

    useImperativeHandle(ref, () => ({
        add: (type) => {
            let data = defaultData
            data.group = type
            setPopup(prev => ({
                ...prev,
                edit: false,
                loading: false,
                data: data,
                dataLoading: false
            }))
            handleShow()
        },
        edit: (id, options = {}) => {
            setPopup(prev => ({
                ...prev,
                edit: Math.random().toString(),
                editId: id,
                data: defaultData,
                dataLoading: true,
                loading: false,
                customHeading: options.customHeading || null,
            }))
            handleShow()
        },
        duplicate: (msg) => {
            // Open modal in add mode, prefill with msg data
            let data = { ...msg, group: msg.group || msg.status }
            delete data.id
            setPopup(prev => ({
                ...prev,
                edit: false,
                loading: false,
                data: data,
                dataLoading: false
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))

    // при редакция извлича текущите данни, за да се попълнят полетата
    useEffect(() => {
        if (popup.edit) {
            Api.get(`text-messages/find?id=${popup.editId}`)
                .then(res => {

                    let data = res.data

                    data.original = data.receivers
                    data.characters = data.text.length

                    setPopup(prev => ({
                        ...prev,
                        data: data,
                        dataLoading: false,
                    }))
                })
        }

    }, [popup.edit])

    useEffect(() => {
        if (popup.data.group) {

            let url

            switch (popup.data.group) {
                case 'team':
                    url = 'partners/employees/all?active=1&sort=name'
                    break
                case 'advert':
                    url = 'customers/all'
                    break
            }

            setPopup(prev => ({
                ...prev,
                url: url,
            }))

        }
    }, [popup.data.group])

    useEffect(() => {
        let data = []

        popup.data.receivers.map(r => {
            if (r.user) {
                data.push(r.user)
            }
        })

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                selected: data,
            }
        }))

    }, [popup.data.receivers])

    useEffect(() => {
        if (Number(popup.data.send_to_all) === 1) {
            setPopup(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    receivers: []
                }
            }))
        } else {
            setPopup(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    receivers: popup.data.original || []
                }
            }))
        }
    }, [popup.data.send_to_all])

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        if (e) {
            e.preventDefault()
        }

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setValidations(null)

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
        }, 50)
    }

    const handleSave = e => {

        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url

        if (popup.edit) {
            url = 'text-messages/edit'
        } else {
            url = 'text-messages/add'
        }

        let data = new FormData(e.target)

        // при редакция - добавяме ID
        if (popup.edit) {
            data.append('id', popup.editId)
        }

        data.append('type', popup.data.group)

        Api.post(url, data)
            .then(res => {

                if (popup.edit) {
                    props.handleUpdate(res.data)
                } else {
                    props.handleCreate(res.data)
                }

                handleHide()

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))

        if (name === 'text') {
            let characters = val.length

            setPopup(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    characters: characters
                }
            }))
        }
    }

    const handleCheckboxChange = e => {
        let name = e.target.name

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: typeof prev.data[name] === 'undefined' || Number(prev.data[name]) === 0 ? 1 : 0
            }
        }))
    }

    const handleDateChange = e => {
        let name = e.target.name + '_ymd'
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const getRepeatNumbers = () => {
        let n = []

        for (let i = 1; i <= 31; i++) {
            n.push(i)
        }

        return n
    }

    const handleChangeReceivers = data => {

        let receivers = []

        data.map(user => {
            let receiver = {
                id: Math.random().toString().substring(3),
                user_id: user.id,
                user: user
            }

            receivers.push(receiver)
        })

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                receivers: receivers,
                original: receivers
            }
        }))

    }

    const handleRemoveReceiver = userId => {
        let receivers = [...popup.data.receivers]

        receivers = receivers.filter(r => {
            return Number(r.user_id) !== Number(userId)
        })

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                receivers: receivers,
                original: receivers
            }
        }))
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form ref={formRef} className={`${popup.modal ? 'show' : ''} popup-text-message popup-primary large`} autoComplete="off" onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={headImage} alt="head" />
                    <div className='texts'>
                        <h2>
                            {popup.customHeading
                                ? trans('headings.send-smsMessage')
                                : (popup.edit ? trans('headings.edit-smsMessage') : trans('headings.add-smsMessage'))
                            }
                        </h2>
                        <p>
                            {trans('subheadings.addEditUniversal')}
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}></span>
                </div>


                {popup.dataLoading
                    ?
                    <img className="loader" src={loader} />
                    :
                    <>
                        <div className="row">
                            <div className="col">
                                <label htmlFor="heading">{trans('labels.heading')}*</label>
                                <input
                                    name="subject"
                                    type="text"
                                    id="heading"
                                    className={validations && validations.subject ? 'validate' : ''}
                                    value={popup.data && popup.data.subject ? popup.data.subject : ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="col">
                                <label htmlFor="method">{trans('labels.type')}*</label>
                                <select
                                    name="method"
                                    id="method"
                                    value={popup.data && popup.data.method ? popup.data.method : 'sms'}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="sms">SMS</option>
                                    <option value="email">Email</option>
                                </select>
                            </div>
                            <div className="col">
                                <label htmlFor="send_at">{trans('labels.dateSent')}*</label>
                                <input
                                    name="send_at"
                                    type="datetime-local"
                                    id="send_at"
                                    className={validations && validations.send_at ? 'validate' : ''}
                                    value={popup.data && popup.data.send_at_ymd ? popup.data.send_at_ymd : ''}
                                    disabled={popup.data && Number(popup.data.send_now) === 1}
                                    onChange={handleDateChange}
                                    required
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="send_now"
                                            value="1"
                                            checked={popup.data && Number(popup.data.send_now) === 1}
                                            onChange={handleCheckboxChange}
                                            size='small'
                                        />
                                    }
                                    label={trans('labels.send-immediately')}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col recievers-container">
                                <label>
                                    {trans('labels.sendTo')}
                                </label>
                                {popup.data.method === 'sms'
                                    ?
                                    <Dropdown
                                        key={1}
                                        inputIdName="receivers"
                                        url={popup.url}
                                        multiple={true}
                                        loadDataOnFocus={true}
                                        selectedValues={popup.data.selected}
                                        inputPlaceholder={trans('labels.findUsers')}
                                        inputClassName={validations && validations.receivers ? 'validate' : ''}
                                        inputDisabled={popup.data && Number(popup.data.send_to_all) === 1 ? true : false}
                                        onChange={handleChangeReceivers}
                                        renderText={data => {
                                            return <span>{data.full_name} ({(data.phone_formatted || trans('labels.noPhone'))})</span>
                                        }}
                                        showAvatarsOnMultiple
                                    />
                                    :
                                    <Dropdown
                                        key={2}
                                        inputIdName="receivers"
                                        url={popup.url}
                                        multiple={true}
                                        loadDataOnFocus={true}
                                        selectedValues={popup.data.selected}
                                        inputPlaceholder={trans('labels.findUsers')}
                                        inputClassName={validations && validations.receivers ? 'validate' : ''}
                                        inputDisabled={popup.data && Number(popup.data.send_to_all) === 1 ? true : false}
                                        onChange={handleChangeReceivers}
                                        renderText={data => {
                                            return <span>{data.full_name} ({((popup.data.group === 'advert' ? data.email2 : data.email) || trans('labels.noEmail'))})</span>
                                        }}
                                        showAvatarsOnMultiple
                                    />
                                }
                                {/* <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="send_to_all"
                                            value="1"
                                            checked={popup.data && Number(popup.data.send_to_all) === 1 ? true : false}
                                            onChange={handleCheckboxChange}
                                            size='small'
                                        />
                                    }
                                    label={trans('labels.sendAll')}
                                /> */}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="enable_send_condition"
                                            checked={popup.data && popup.data.enable_send_condition ? true : false}
                                            onChange={handleCheckboxChange}
                                            size='small'
                                        />
                                    }
                                    label={trans('labels.sendOnCondition')}
                                />
                                {popup.data && popup.data.enable_send_condition ? (
                                    <>
                                        <label>
                                            {trans('labels.chooseCondition')}
                                        </label>
                                        <select
                                            name="send_condition"
                                            id="send_condition"
                                            value={popup.data && popup.data.send_condition ? popup.data.send_condition : ''}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Избор</option>
                                            <option value="reservation_completed">{trans('labels.clientHasCompletedReservation')}</option>
                                        </select>
                                    </>
                                ) : null}
                            </div>
                            <div className='col'>
                                {popup.data && !popup.data.parent_id
                                    ?
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="repeat"
                                                value="1"
                                                checked={popup.data && Number(popup.data.repeat) === 1 ? true : false}
                                                onChange={handleCheckboxChange}
                                                size='small'
                                            />
                                        }
                                        label={trans('labels.repeat')}
                                    />
                                    :
                                    ''
                                }

                                {popup.data && Number(popup.data.repeat) === 1
                                    ?
                                    <div className="row">
                                        <div className="col">
                                            <label>
                                                {trans('labels.repeatOn')}
                                            </label>
                                            <select
                                                name="repeat_after"
                                                className={validations && validations.repeat_after ? 'validate' : ''}
                                                value={popup.data && popup.data.repeat_after ? popup.data.repeat_after : ''}
                                                onChange={handleInputChange}
                                            >
                                                {getRepeatNumbers().map((n, i) => (
                                                    <option key={'rn-' + i} value={n}>
                                                        {n}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col">
                                            <label>
                                                {trans('labels.period')}
                                            </label>
                                            <select
                                                name="repeat_period"
                                                className={validations && validations.repeat_period ? 'validate' : ''}
                                                value={popup.data && popup.data.repeat_period ? popup.data.repeat_period : ''}
                                                onChange={handleInputChange}
                                            >
                                                <option value={1}>
                                                    {popup.data && (!popup.data.repeat_after || Number(popup.data.repeat_after) === 1)
                                                        ? trans('labels.day')
                                                        : trans('labels.days')
                                                    }
                                                </option>
                                                <option value={2}>
                                                    {popup.data && (!popup.data.repeat_after || Number(popup.data.repeat_after) === 1)
                                                        ? trans('labels.week')
                                                        : trans('labels.weeks')
                                                    }
                                                </option>
                                                <option value={3}>
                                                    {popup.data && (!popup.data.repeat_after || Number(popup.data.repeat_after) === 1)
                                                        ? trans('labels.month')
                                                        : trans('labels.months')
                                                    }
                                                </option>
                                                <option value={4}>
                                                    {popup.data && (!popup.data.repeat_after || Number(popup.data.repeat_after) === 1)
                                                        ? trans('labels.year')
                                                        : trans('labels.years')
                                                    }
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    :
                                    ''
                                }
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <label htmlFor="text">
                                    {trans('labels.content')}
                                </label>
                                {popup.data.method === 'email'
                                    ?
                                    <Ckeditor
                                        adkey="text"
                                        name="text"
                                        value={popup.data && popup.data.text ? popup.data.text : ''}
                                    />
                                    :
                                    <>
                                        <textarea
                                            id="text"
                                            name="text"
                                            className={validations && validations.text ? 'validate' : ''}
                                            value={popup.data && popup.data.text ? popup.data.text : ''}
                                            onChange={handleInputChange}
                                        >
                                        </textarea>
                                        <div style={{ marginTop: '10px', fontSize: '10px' }}>
                                            <span>
                                                {trans('labels.characters')}: <span className="">{popup.data.characters}</span>
                                            </span>
                                            /
                                            <span>
                                                {trans('labels.smses')}: <span className="">{Math.ceil(popup.data.characters / charactersPerSms) || 1}</span>
                                            </span>
                                        </div>

                                    </>
                                }

                            </div>
                        </div>

                    </>
                }

                <div className="footer">
                    {popup.loading ? (
                        <img src={loader} alt="loading" />
                    ) : (
                        <>
                            <button className="button" onClick={handleHide} type="button">
                                {trans('buttons.cancel') || 'Отказ'}
                            </button>
                            {popup.customHeading ? (
                                <button className="button button-primary" type="button" onClick={handleSendMessage}>
                                    {trans('buttons.send') || 'Изпрати'}
                                </button>
                            ) : (
                                <button className="button button-primary" type="submit">
                                    {trans('buttons.save') || 'Запази промените'}
                                </button>
                            )}
                        </>
                    )}
                </div>
            </form>
        </div>
    )
}

export default React.forwardRef(AddOrEdit)